// @flow
import Resource from 'speed-js-core/src/api/NestedResource';

export default class EmployeeResource extends Resource {
    basePath: string = 'entities/organisations/{parent}/employees/';

    objectPath: string = 'entities/organisations/{parent}/employees/{ident}/';
}
